export default {
  peakzBlue: '#54bcd9',
  peakzRed: '#eb5636',
  peazkGreen: '#54b9af',
  discount: '#E43A36',
};
